import { bl_del_job_dochdr_link_RowClass, bl_del_job_docline_link_RowClass, bl_del_job_hdr_RowClass, bl_del_job_shipment_link_RowClass, bl_del_shipment_hdr_RowClass, bl_fi_generic_doc_ext_RowClass, bl_fi_generic_doc_hdr_RowClass, bl_fi_generic_doc_line_RowClass } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class JobSalesOrderContainerModel extends BaseContainerModel {
  bl_del_job_hdr: bl_del_job_hdr_RowClass = new bl_del_job_hdr_RowClass();
  bl_del_job_dochdr_link: bl_del_job_dochdr_link_RowClass = new bl_del_job_dochdr_link_RowClass;
  bl_fi_generic_doc_hdr: bl_fi_generic_doc_hdr_RowClass = new bl_fi_generic_doc_hdr_RowClass;
  bl_fi_generic_doc_lines: bl_fi_generic_doc_line_RowClass[] = [];
  bl_fi_generic_doc_exts: bl_fi_generic_doc_ext_RowClass[] = [];
  bl_del_job_docline_links: bl_del_job_docline_link_RowClass[] = [];
}